// flutter.events.js
// Global handler for events propagated from Flutter iFrames
import { resizeFrame, parseJSONRecursively, isLikelyJSON } from './flutter.utils.js';

// Global event handler
// usage.js (remains the same)
import FlutterDeals from '../widgets/flutter-deals/flutter.deals.js';
import FlutterGiftVoucher from '../widgets/flutter-gift-voucher/flutter-gift-voucher.js';
import FlutterPreviewPane from '../widgets/flutter-preview-pane/flutter-preview-pane.js';
import FlutterAccommodationSingleListing from '../widgets/flutter-accommodation/flutter-accommodation-single-listing.js';
import FlutterCheckout from '../widgets/flutter-checkout/flutter-checkout.js';

const flutterDeals = new FlutterDeals();
const flutterVouchers = new FlutterGiftVoucher();
const flutterPreviewPane = new FlutterPreviewPane();
const flutterAccommodationSingleListing = new FlutterAccommodationSingleListing();
const flutterCheckout = new FlutterCheckout();

function handleFlutterEvent(message) {
  if (process.env.NODE_ENV === 'development') {
    console.log('flutter.events.flutterEventHandler: received message', message);
  }
  const eventPayload = message.data;
  let eventData = eventPayload.data;
  eventData = parseJSONRecursively(eventData);

  const eventSender = eventPayload.sender
  const eventType = eventPayload.type
  if (process.env.NODE_ENV === 'development') {
    console.log('flutter.events.flutterEventHandler: received payload from iframe: ', {
      sender: eventSender,
      type: eventType,
      data: eventData
    })
  }

  switch (eventSender) {
    case 'checkout':
    case 'orders':
    case 'order':
      flutterCheckout.handleEvent(eventType, eventData);
      break;
    case 'deals':
    case 'featured-deals':
      flutterDeals.handleEvent(eventType, eventData);
      break;
    case 'vouchers':
      flutterVouchers.handleEvent(eventType, eventData);
      break;
    case 'park_availability':
      flutterPreviewPane.handleEvent(eventType, eventData);
      break;
    case 'accommodation_info':
      flutterAccommodationSingleListing.handleEvent(eventType, eventData);
      break;

    default:
      console.warn('flutter.events.flutterEventHandler: Unhandled event', eventPayload);
      break;
  }
  return;
}
window.dbs.globalEvents.subscribe('flutter.message', (message) => {
  handleFlutterEvent(message);
});

if (process.env.NODE_ENV === 'development') {
  console.log('flutter.events: loaded and added handler');
}

